import React, { useState } from "react"
import { setPaymentGatewaysField, fetchPaymentGateways, cancelLastPaymentGateway } from "../../../../../actions/paymentGatewaysActions";
import { ConfigConstants } from "../../../../../utils/config";
import { IPaymentGatewayElement } from "../../../../../models/Configuration";
import { UpdateBraintreeGatewayRequest } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/payment_gateway_pb";
import { PaymentGatewayServiceClient } from "../../../../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/Payment_gatewayServiceClientPb";
import { grpcUnaryCall } from "../../../../../utils/grpc/grpcUtils";
import PaymentGatewayContainer from "../payment-gateways-shared-components/PaymentGatewayContainer";
import BrainTreePaymentGatewayUpdateForm from "./BrainTreePaymentGatewayUpdateForm";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../..";
import { IAuthReducerState } from "../../../../../reducers/authReducer";

interface Props {
  paymentGateway: IPaymentGatewayElement,
  isOneGatewayPending: boolean,
  currentGatewayState: any,
  idx: number,
  isCreatingGateway: boolean,
  onError: () => void
}

interface IData {
  merchantAccountId: string,
  currencyIsoCode: string,
  isSandbox: boolean
}

const BrainTreePaymentGatewayUpdate: React.FC<Props> = ({ onError, paymentGateway, isOneGatewayPending, currentGatewayState, idx, isCreatingGateway }) => {

  const { currentCompanyDomain } = useSelector<AppState, IAuthReducerState>(state => state.auth)
  const dispatch = useDispatch<Function>()
  const data = paymentGateway.data as IData;
  const [helpTitle, setHelpTitle] = useState("PAYMENT_GATEWAYS_ADDED_BRAINTREE_HELP_TITLE");
  const [helpContent, setHelpContent] = useState(["PAYMENT_GATEWAYS_ADDED_BRAINTREE_HELP_CONTENT_1", "PAYMENT_GATEWAYS_ADDED_BRAINTREE_HELP_CONTENT_2"]);
  

  const cancelChanges = () => {
    paymentGateway.mustActivate ? dispatch(cancelLastPaymentGateway())
      : dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, displayName: paymentGateway.title, isCollapsed: true }))
  }

  const updatePaymentGateway = async (displayName: string, merchantId: string, publickKey: string, privateKey: string) => {
    const updateBraintreeGatewayRequest = new UpdateBraintreeGatewayRequest();
    updateBraintreeGatewayRequest.setCompanyDomain(currentCompanyDomain);
    updateBraintreeGatewayRequest.setDisplayName(displayName);
    updateBraintreeGatewayRequest.setMerchantId(merchantId);
    updateBraintreeGatewayRequest.setPublicKey(publickKey);
    updateBraintreeGatewayRequest.setPrivateKey(privateKey);
    updateBraintreeGatewayRequest.setPaymentGatewayId(paymentGateway.paymentGatewayId as number);
    const paymentGatewayServiceClient = new PaymentGatewayServiceClient(ConfigConstants.grpcBaseUrl);
    try {
      await grpcUnaryCall(updateBraintreeGatewayRequest, paymentGatewayServiceClient, paymentGatewayServiceClient.updateBraintreeGateway);
      await dispatch(fetchPaymentGateways(currentCompanyDomain));
      dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, isCollapsed: true }))
    } catch {
      onError();
    }
  }

  return (    
    <PaymentGatewayContainer
      helpTitle={helpTitle}
      helpContent={helpContent}
      description="PAYMENT_GATEWAYS_BRAINTREE_DESCRIPTION"
      isOneGatewayPending={isOneGatewayPending}
      currentGatewayState={currentGatewayState}
      onClick={() => dispatch(setPaymentGatewaysField(`paymentGateway${idx}`, { ...currentGatewayState, isCollapsed: paymentGateway.mustActivate ? false : !currentGatewayState.isCollapsed }))}
      websiteLink="https://www.braintreepayments.com/"
      type="edit"
      paymentGateway={paymentGateway}
    >
      <BrainTreePaymentGatewayUpdateForm
        onSave={(displayName: string, userName: string, password: string, merchantAccount: string) => updatePaymentGateway(displayName, userName, password, merchantAccount)}
        onCancel={() => cancelChanges()}
        setHelpTitle={(text: string) => setHelpTitle(text)}
        setHelpContent={(text: Array<string>) => setHelpContent(text)}        
        isSaveEnabled={!isCreatingGateway}
        isEdit={true}
        initDisplayName={paymentGateway.title}
        initCurrencyCode={data.currencyIsoCode}
        initMerchantAccountId={data.merchantAccountId}
        isSandbox={data.isSandbox ? data.isSandbox : false}
        initMerchantId=""
        initPrivateKey=""
        initPublicKey=""
      />
    </PaymentGatewayContainer>
  )
}

export default BrainTreePaymentGatewayUpdate
